<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 556 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction v-if="navType == 'Super Admin'" flat :content-to-render="$options.nav_super_admin"/>
    <CRenderFunction v-else-if="navType == 'Article Writer'" flat :content-to-render="$options.nav_article_writer"/>
    <CRenderFunction v-else flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'
import nav_article_writer from './_nav_article_writer'
import nav_super_admin from './_nav_super_admin'
import store from '@/store.js'
import { mapActions } from 'vuex'

export default {
  name: 'TheSidebar',
  nav,nav_article_writer,nav_super_admin,
  data() {
    return {
      navType:''
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  async created(){
    await this.getUserLogin()
    // console.log(store.state.user.authenticated.roles[0].name)
    this.navType = store.state.user.authenticated.roles[0].name
    // console.log(this.navType)
  },
  methods: {
    ...mapActions('user', ['getUserLogin']),
  }
}
</script>
